import { useEffect } from "react";
import { useAuth } from "../../hooks/useAuth";

export default function SignOutPage() {
  const { logout } = useAuth();

  useEffect(() => {
    logout();
  }, [logout]);

  return null;
}
